module.exports = __webpack_public_path__ + "img/20190917174047602.4e670a9c.jpg";